import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

/**
 * Turn a stored path into a full URL loadable in <img src> or fetchable.
 * - Full URLs (http/https): returned as-is.
 * - Legacy paths ("/api/uploads/..."): kept for backward compat only — these
 *   files were on the ephemeral disk and will 404 after redeploy.
 * - Storage paths ("royalgames/..." from Emergent object storage) → served
 *   through the backend proxy at /api/files/{path}.
 */
export function resolveUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${BACKEND_URL}/api/files/${path}`;
}
